import { Box, Grid } from "@material-ui/core";
import { Form } from "@components";
import React, { useState, useEffect, useCallback, useContext } from "react";
import { useHistory } from "react-router";
import { UPDATE_FILTERS_DATA } from "../state";
import { TableContext } from "../table";
import { Search } from "./search-filters";
import { Actions } from "../../../screens/request/components/actions";

import { createStyles, Theme, WithStyles } from "@material-ui/core/styles";
import { SalesforceProfileDetail } from "../../../screens/dashboard/admin/maintenance/salesforceprofile/detail";
import { SalesforceProfileModel } from "@api/types/salesforceprofile";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

interface Props {
  onClickAdd: () => void;
}

export const SalesforceProfileToolbar: React.FC<Props> = ({}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { dispatch } = useContext(TableContext);
  const [] = React.useState<boolean>(false);
  const [] = React.useState(false);
  const onSearchUpdate = useCallback(
    (term: string) => {
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { searchTerm: term },
      });
    },
    [dispatch]
  );

  useEffect(() => {
    if (!openModal) {
      // clear form if modal has closed
      form.reset();
    }
  }, [openModal]);

  const form = Form.useManager<SalesforceProfileModel>({
    id: 0,
    profileName: "",
    userType: "",
    isActive: false,
    region: "",
  });

  const handleClickOpen = () => {
    setOpenModal(true);
  };

  const isShowModal = openModal ? (
    <SalesforceProfileDetail
      form={form}
      open={openModal}
      onCancel={() => setOpenModal(false)}
    />
  ) : null;

  return (
    <Box mt={2} mb={2}>
      <Grid container direction="row" spacing={1} justify="space-between">
        <Grid item xs={"auto"}>
          <Actions>
            <Actions.Action onClick={handleClickOpen}>
              + Add New Profile
            </Actions.Action>
          </Actions>
        </Grid>
        <Grid item xs={3}>
          <Search
            onSearchUpdate={onSearchUpdate}
            placeholder={"Search by Profile Name"}
          ></Search>
        </Grid>
      </Grid>
      {isShowModal}
    </Box>
  );
};
